exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".about-container{width:100%;margin:0;padding:10px;background-image:url(/images/background.jpg);background-size:contain;font-size:9pt;text-align:center}.about-text{width:300px;margin:auto;line-height:1.25}.about-text .dice{margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/About.css
// module id = 717
// module chunks = 0